import { manageQuizActionTypes } from './Constants';
import { change, reset } from 'redux-form';

export function toggleManageQuizModal(data) {
	return {
		type: manageQuizActionTypes.TOGGLE_MANAGE_QUIZ_MODAL,
		payload: {
			data,
		},
	};
}

export function getSubjects(source, params) {
	return {
		type: manageQuizActionTypes.GET_QUIZ_AVAILABLE_SUBJECTS,
		payload: {
			source,
			params,
		},
	};
}

export function getSubjectsSuccess(data) {
	return {
		type: manageQuizActionTypes.GET_QUIZ_AVAILABLE_SUBJECTS_SUCCESS,
		payload: {
			data,
		},
	};
}

export function getSubjectsError(error) {
	return {
		type: manageQuizActionTypes.GET_QUIZ_AVAILABLE_SUBJECTS_ERROR,
		payload: {
			error,
		},
	};
}

export function getTopics(subjectId) {
	return {
		type: manageQuizActionTypes.GET_QUIZ_AVAILABLE_TOPICS,
		payload: { subjectId },
	};
}

export function getTopicsSuccess(data) {
	return {
		type: manageQuizActionTypes.GET_QUIZ_AVAILABLE_TOPICS_SUCCESS,
		payload: { data },
	};
}

export function getTopicsError() {
	return {
		type: manageQuizActionTypes.GET_QUIZ_AVAILABLE_TOPICS_ERROR,
	};
}

export function manageQuiz(formData, editId, callback) {
	return {
		type: manageQuizActionTypes.MANAGE_QUIZ,
		payload: {
			formData,
			editId,
			callback,
		},
	};
}

export function manageQuizSuccess(invitedGroups) {
	return {
		type: manageQuizActionTypes.MANAGE_QUIZ_SUCCESS,
		payload: {
			invitedGroups,
		},
	};
}

export function manageQuizError(error) {
	return {
		type: manageQuizActionTypes.MANAGE_QUIZ_ERROR,
		payload: {
			error,
		},
	};
}

export function changeFormField(formName, fieldName, value) {
	return change(formName, fieldName, value);
}

export function resetForm(formName) {
	return reset(formName);
}

export function cleanManageQuizState() {
	return {
		type: manageQuizActionTypes.CLEAN_MANAGE_QUIZ_STATE,
	};
}
